import { render, staticRenderFns } from "./bag-tick.vue?vue&type=template&id=7886d832&"
import script from "./bag-tick.vue?vue&type=script&lang=js&"
export * from "./bag-tick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports